import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserInfo} from '@app/model/user-info.model';
import {LanguageService} from '@app/service/language.service';
import {BehaviorSubject} from 'rxjs';

@Component({
	selector: 'app-mobile-menu',
	templateUrl: './mobile-menu.component.html',
	styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent {
	@Input() userInfo!: UserInfo | null;
	@Output() toggleVisibility = new EventEmitter();
	showLanguages = new BehaviorSubject<boolean>(false);

	constructor(public languageService: LanguageService) {
	}


}
